module.exports = __webpack_public_path__ + "img/leaf-heart.40824360.svg";